import { Component, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';


@Component({
selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SearchComponent {

  @Output() onSearch = new EventEmitter<String>();

  // FORM
  get f() {
    return this.searchForm.controls;
  }
  searchForm = this.fb.group({
    search: [''],
  });

  constructor(private fb: FormBuilder) { }

  onChangeInput() {
    this.onSearch.emit(this.f.search.value);
  }
}
